/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Casedatasectiondispute3Inputs */

const en_casedatasectiondispute3 = /** @type {(inputs: Casedatasectiondispute3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The dispute`)
};

const pt_casedatasectiondispute3 = /** @type {(inputs: Casedatasectiondispute3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A disputa`)
};

/**
* | output |
* | --- |
* | "The dispute" |
*
* @param {Casedatasectiondispute3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const casedatasectiondispute3 = /** @type {((inputs?: Casedatasectiondispute3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Casedatasectiondispute3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_casedatasectiondispute3(inputs)
	return pt_casedatasectiondispute3(inputs)
});
export { casedatasectiondispute3 as "caseDataSectionDispute" }